var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-config-provider',{attrs:{"locale":_vm.locale}},[_c('div',{attrs:{"id":"app"}},[_c(_vm.layout,{tag:"component"},[_c('router-view')],1),_c('dialog-manager'),_c('side-page-manager'),_c('window-resize-listener'),_c('oc-term')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }